<template>
  <v-container>
    <taxReasonCode />
  </v-container>
</template>

<script>
import taxReasonCode from '../../components/shared/taxReasonCode/taxReasonCode.vue';

export default {
  name: 'TaxReasonCode',
  components: {
    taxReasonCode,
  },
};
</script>
